import { useState, useEffect } from 'react';
import { json } from 'react-router-dom';
import Axios from '../utils/axiosInstance';

const useOrderStatuses = () => {
  const [orderStatuses, setOrderStatuses] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  useEffect(() => {
    const fetchOrderStatuses = async () => {
      try {
        const response = await Axios.get(`${process.env.REACT_APP_API_BASE_URL}shipment/orderStatus`);
        var tempArr=[];
        response.data.map((item) =>  {
            if(item.status == "Cancelled"){

            }
            else
            tempArr.push(item.status)
        })
        setOrderStatuses(tempArr);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrderStatuses();
  }, []);

  return { orderStatuses};
};

export default useOrderStatuses;
